import { useState } from 'react'
import { ActionIcon, Group, Text } from '@mantine/core'
import { IconSettings } from '@tabler/icons-react'
import { UserPreferencesModal } from './UserPreferences'

/**
 * Dashboard Header Component (TASK-1226)
 *
 * Displays dashboard title and preferences button
 */
export interface DashboardHeaderProps {
  title: string
}

export function DashboardHeader({ title }: DashboardHeaderProps) {
  const [preferencesOpened, setPreferencesOpened] = useState(false)

  return (
    <>
      <Group justify="space-between">
        <Text size="lg" fw={600}>{title}</Text>
        <ActionIcon
          variant="subtle"
          size="lg"
          onClick={() => setPreferencesOpened(true)}
          title="Minhas preferências"
        >
          <IconSettings size={20} />
        </ActionIcon>
      </Group>
      <UserPreferencesModal
        opened={preferencesOpened}
        onClose={() => setPreferencesOpened(false)}
      />
    </>
  )
}
